module.exports = __webpack_public_path__ + "static/media/sense4180.41c0671f.jpg";